import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'

import { getCurrentSession } from '../lib/authentication'

const httpLink = createHttpLink({
  uri: `${OE_ENV.API_GATEWAY_URL}/graphql`,
})

const authLink = setContext(async (_, { headers }) => {
  const { accessToken } = await getCurrentSession()
  return {
    headers: {
      ...headers,
      Authorization: accessToken,
    },
  }
})

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
})

export default client
